<template>
  <b-button ref="b1" @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? 'Редактировать' : ''">
    <i v-if="!readonly" class="fa fa-edit"></i>
    <i v-if="readonly" class="fa fa-info-circle"></i>
    </b-button>
</template>

<script>

export default ({
  name: "button-edit",

  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
})
</script>
